import axios from "axios";
import { toast } from "react-toastify";
import authHeader from "./auth-header";

export const generateStockReport = (data) =>
  axios
    .post(`${process.env.REACT_APP_BASE_URL}/stock-report`, data, {
      headers: authHeader(),
    })
    .then((res) => {
      toast.success(res.data.msg);
      return res.data.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg || "Error generating stock report");
      throw err;
    });
